export const environment = {
  production: true,
  _baseUrl : 'https://testapi.techpolabs.net',
  keycloak_client_id: 'ininal-panel-client',
  groupPrefix: 'company-'
};
